const iconEyes = document.querySelectorAll(".eye-icon");

if (iconEyes) {
  iconEyes.forEach((iconEye) => {
    iconEye.addEventListener("click", () => {
      const input = document.querySelector(iconEye.dataset.inputPassword);

      if (!(input.hasAttribute("type"))) return;
      const eyeClose = document.querySelector(iconEye.dataset.closeEye);
      const eyeOpen = document.querySelector(iconEye.dataset.openEye);

      if (input.getAttribute("type") === "password") {
        input.setAttribute("type", "text");

        eyeClose.classList.add("d-none")
        eyeOpen.classList.remove("d-none")
      } else {
        input.setAttribute("type", "password");

        eyeClose.classList.remove("d-none")
        eyeOpen.classList.add("d-none")
      }
    })
  })
}
